<div class="row mb-2" [class.pointer-cursor]="arrowIcon">
  <div
    class="col-3 text-center d-flex flex-row justify-content-center align-items-center"
  >
    <img src="{{ imagesource }}" class="icon" role="button" />
  </div>
  <div class="col-6 heading d-flex flex-column">
    <p
      class="title"
      [ngClass]="description === undefined ? 'pt-1 my-4' : 'pt-3 my-1'"
    >
      <app-with-tooltip [showHelpCursor]="false">{{ title }}</app-with-tooltip>
    </p>
    <p class="description" *ngIf="description; else empty">
      <app-with-tooltip [showHelpCursor]="false">{{
        description
      }}</app-with-tooltip>
    </p>
    <ng-template class="description" #empty>&nbsp;</ng-template>
  </div>
  <div></div>
  <div
    class="col-3 text-right d-flex flex-row justify-content-end align-items-center pr-3"
  >
    <img *ngIf="arrowIcon" src="assets/svg/ico-chevron-forward-outline.svg" />
  </div>
</div>
